import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../base-component/base-component";

import VScroll from "src/core/gd-components/scrolling/custom-v-scroll/v-scroll";
import Loading from "../../gd-ui/loading/loading";

import Classes from 'classnames';

export default class ModalOptionsSelection extends BaseComponent {

    static propTypes = {
        options: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.string,
            label: PropTypes.string
        })),

        onSelectOption: PropTypes.func,
        onEditOption: PropTypes.func,
        onDeleteOption: PropTypes.func
    };

    state = {
        options: this.props.options
    };

    setOptions(options) {
        this.setState({
            options: options
        })
    }

    onSelectOption = (id, e) => {e.stopPropagation(); if (this.props.onSelectOption) this.props.onSelectOption(id)}
    onEditOption = (id, e) => {e.stopPropagation(); if (this.props.onEditOption) this.props.onEditOption(id)}
    onDeleteOption = (id, e) => {e.stopPropagation(); if (this.props.onDeleteOption) this.props.onDeleteOption(id)}

    render() {
        return (
            <div className={Classes("gd-modal-options-selection-new", this.props.className)}>
                <VScroll>
                    {!this.state.options && <Loading />}

                    {this.state.options &&
                    <div className="modal-options-selection-container">
                        {this.state.options.map(item=>
                            <div key={item.id} className={Classes("modal-options-item", {'with-lock': item.showLock})} onClick={this.onSelectOption.bind(this,item.id)}>

                                <div className="label">
                                    {!!item.icon && <div className={Classes("icon", "ui5-ico-12", item.icon)}/>}
                                    {item.label}
                                </div>

                                {item.showLock && <div className="lock-icon ui5-ico-12 i5-lock"/>}

                                {item.editable &&
                                <div className="actions">
                                    <div className="action-button gd-btn-edit-black-18" onClick={this.onEditOption.bind(this,item.id)}/>
                                    <div className="action-button gd-btn-circle-delete-red-18" onClick={this.onDeleteOption.bind(this,item.id)}/>
                                </div>}

                            </div>)}

                        {this.props.children}
                    </div>}
                </VScroll>
            </div>
        )
    }
};